import React from 'react';
import { Breadcrumbs, Link, Box, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext'; // Import breadcrumb context

const TitleBar = styled(Box)`
  background-color: white;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 64px;
  width: 100%;
  z-index: 1100;
  flex-grow: 1;
  transition: margin-left 0.3s;
  margin-left: ${({ open }) => (open ? '200px' : '0')};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: textPrimary;
  cursor: pointer;
`;


const PageTitleBar = ({ open }) => {
    const navigate = useNavigate();
    const { breadcrumb } = useBreadcrumb(); // Get breadcrumb data from context

    const handleClick = (url) => {
        navigate(url);
    };

    return (
        <TitleBar open={open}>
            <Breadcrumbs aria-label="breadcrumb">
                {breadcrumb.map((crumb, index) => (
                    crumb.link ?
                        <StyledLink key={index} onClick={() => handleClick(crumb.link)}>
                            {crumb.label}
                        </StyledLink> :
                        <Typography key={index} color="textPrimary">
                            {crumb.label}
                        </Typography>
                ))}
            </Breadcrumbs>
        </TitleBar>
    );
};

export default PageTitleBar;
